// extracted by mini-css-extract-plugin
export var avatar = "ReceivedMessage-module--avatar--d15b8";
export var balloon = "ReceivedMessage-module--balloon--5fb43";
export var content = "ReceivedMessage-module--content--d593b";
export var isFirstMessage = "ReceivedMessage-module--isFirstMessage--a43f9";
export var isLastMessage = "ReceivedMessage-module--isLastMessage--8f83f";
export var receivedMessage = "ReceivedMessage-module--receivedMessage--8b78e";
export var timestamp = "ReceivedMessage-module--timestamp--4e899";